import React from "react";
import { useKnockFeed } from "../KnockFeedProvider";
import { formatBadgeCount } from "../../utils";

function selectBadgeCount(badgeCountType, metadata) {
  switch (badgeCountType) {
    case "all":
      return metadata.total_count;

    case "unread":
      return metadata.unread_count;

    case "unseen":
      return metadata.unseen_count;
  }
}

export var UnseenBadge = _ref => {
  var {
    badgeCountType = "unseen"
  } = _ref;
  var {
    useFeedStore
  } = useKnockFeed();
  var badgeCountValue = useFeedStore(state => selectBadgeCount(badgeCountType, state.metadata));
  return badgeCountValue !== 0 ? /*#__PURE__*/React.createElement("div", {
    className: "rnf-unseen-badge"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rnf-unseen-badge__count"
  }, formatBadgeCount(badgeCountValue))) : null;
};
//# sourceMappingURL=UnseenBadge.js.map